import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/Service/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private readonly router: Router, private readonly authenticationService: AuthService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            //console.log('ERROR CARGA: ', err);
            if (err.status == 401) {
                this.router.navigate(['/login']);
            } else if (err.error.path == '/client/page/0') {
                if (localStorage.getItem("isInitLoad") == "1")
                    location.reload();
            }
            const errorObj = {
                status: err.status,
                message: err.message,
                error: err.error,
                statusText: err.statusText
            };

            return throwError(errorObj);
        }));
    }
}
